module.exports = __webpack_public_path__ + "img/ep1-4.beec00e2.png";